import React from 'react';
import { connect } from 'react-redux';
import { localize } from 'core/localization';
import {
  isAttemptsLimited,
  getLimitedAttemptsNumber,
  shouldSubmitAllQuestions
} from 'store/settings/selectors';
import { RootAppState } from 'store/types';
import { getCourseAttempt } from 'store/course/selectors';
import { RemainingAttemptsBlockText } from './RemainingAttemptsBlock.styled';

type RemainingAttemptsBlockProps = {
  isSubmitAtOnce: boolean;
  isLimitedAttempts: boolean;
  allowedAttempts: number;
  usedAttempts: number;
};

export class RemainingAttemptsBlock extends React.Component<RemainingAttemptsBlockProps> {
  render() {
    const { isSubmitAtOnce, isLimitedAttempts, allowedAttempts, usedAttempts } = this.props;
    const remainingAttempts = allowedAttempts - usedAttempts;

    return (
      <RemainingAttemptsBlockText>
        {isSubmitAtOnce &&
          isLimitedAttempts &&
          remainingAttempts > 0 &&
          `(${localize('[remaining attempts]')}${remainingAttempts})`}
      </RemainingAttemptsBlockText>
    );
  }
}

const mapStateToProps = (state: RootAppState) => ({
  isSubmitAtOnce: shouldSubmitAllQuestions(state),
  isLimitedAttempts: isAttemptsLimited(state),
  allowedAttempts: getLimitedAttemptsNumber(state),
  usedAttempts: getCourseAttempt(state)
});
export default connect(mapStateToProps)(RemainingAttemptsBlock);
